import React, { useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InsightsIcon from '@mui/icons-material/Insights';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ACTIONS = [
    { label: 'New project', icon: <AddCircleIcon fontSize="small" />, path: '/dashboard/projects/new' },
    { label: 'Upload file', icon: <UploadFileIcon fontSize="small" />, path: '/dashboard/files' },
    { label: 'Invite team member', icon: <GroupAddIcon fontSize="small" />, path: '/dashboard/team' },
    { label: 'View analytics', icon: <InsightsIcon fontSize="small" />, path: '/dashboard/analytics' },
];

export default function QuickActionsMenu() {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleGo = (path) => {
        navigate(path);
        handleClose();
    };

    return (
        <>
            <Button
                variant="contained"
                onClick={handleOpen}
                endIcon={<KeyboardArrowDownIcon />}
                sx={{ borderRadius: '12px', textTransform: 'none', fontWeight: 600 }}
            >
                Quick actions
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {ACTIONS.map((a) => (
                    <MenuItem key={a.path} onClick={() => handleGo(a.path)}>
                        <ListItemIcon>{a.icon}</ListItemIcon>
                        <ListItemText>{a.label}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
